(() => {
  'use strict';
  const dialog = document.getElementById('sw-legal-guarantee-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let opener;
  const addAppCartNotice = () => {
    const checkout = document.querySelector('.Vtl-CartDrawerCheckout__CheckoutButtonContainer');
    if (!checkout || checkout.parentElement.querySelector('[data-sw-app-warranty]')) return;
    const source = document.querySelector('.sw-warranty-banner [data-sw-warranty-open]');
    if (!source) return;
    const link = source.cloneNode(true);
    link.className = 'sw-warranty-link sw-warranty-link--cart';
    link.setAttribute('data-sw-app-warranty', '');
    checkout.before(link);
  };
  new MutationObserver(addAppCartNotice).observe(document.body, {childList: true, subtree: true});
  addAppCartNotice();
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sw-warranty-open]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = link;
    const image = dialog.querySelector('[data-sw-warranty-src]');
    if (image && !image.getAttribute('src')) image.src = image.dataset.swWarrantySrc;
    if (!dialog.open) dialog.showModal();
    const viewport = dialog.querySelector('.sw-legal-dialog__viewport');
    viewport.scrollTop = 0;
    viewport.scrollLeft = 0;
  });
  dialog.querySelector('[data-sw-warranty-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') event.stopPropagation();
  });
  dialog.addEventListener('close', () => {
    if (opener && opener.isConnected) opener.focus({preventScroll: true});
  });
})();

